<div class="container">
    <finder-park-table
        *ngFor="let location of locations"
        [location]="location"
        [icons]="data.icons"
        [labels]="data.labels">
    </finder-park-table>
</div>
